// extracted by mini-css-extract-plugin
module.exports = {"red":"UiCheck_red_2J1Wh","block":"UiCheck_block_2S7zK","blockFlex":"UiCheck_blockFlex_3xmTt"};